/* eslint-disable max-len */
import { LitElement, html, css } from 'lit';

export class GridFrame extends LitElement {
	static styles = css`
        :host {
            position: relative;
            display: grid;
            width: auto;
            margin: var(--spacing-xl) 0;
            row-gap: var(--spacing-xl);
            grid-gap: var(--spacing-xl);
            grid-template-columns: repeat(auto-fill, minmax(var(--vertical-card-width), 1fr));
        }

        /* The 350px track minimum is wider than a phone's content box, so the
           grid overflowed and pushed the whole page into horizontal scroll.
           min() lets the track collapse to the container instead. Also tighten
           the 2rem gutters, which cost ~15% of a 390px screen. */
        @media (max-width: 1023px) {
            :host {
                grid-template-columns:
                    repeat(auto-fill, minmax(min(var(--vertical-card-width), 100%), 1fr));
                margin: var(--spacing-md) 0;
                row-gap: var(--spacing-md);
                grid-gap: var(--spacing-md);
            }
        }
	`;

	render() {
		return html`
			<slot></slot>  <!-- Slot for child elements -->
		`;
	}
}

customElements.define('studio-gallery-grid-frame', GridFrame);
